import type { SVGProps, ReactNode } from "react";

type IconProps = SVGProps<SVGSVGElement>;

/** Local inline icons for the 12-point view, matched to the site's 24px / 1.75 stroke style. */
function Svg({ children, ...props }: IconProps & { children: ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export function IdentityIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="9" cy="11" r="2.2" />
      <path d="M5.5 16c.6-1.6 2-2.4 3.5-2.4S12 14.4 12.6 16M15 9.5h4M15 13h3" />
    </Svg>
  );
}

export function HistoryRouteIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M4 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM16 18a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z" />
      <path d="M8 6h6a3 3 0 0 1 0 6H9a3 3 0 0 0 0 6h5" />
    </Svg>
  );
}

export function OccupancyIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="m3 10 9-7 9 7" />
      <path d="M5 9v11h14V9" />
      <circle cx="9.5" cy="14" r="1.4" />
      <circle cx="14.5" cy="14" r="1.4" />
    </Svg>
  );
}

export function RegisterIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
      <path d="M14 3v5h5M9 12h6M9 16h4M9 8h1" />
    </Svg>
  );
}

export function PhoneIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M6.5 3h3l1.5 4.5-2 1.5a12 12 0 0 0 6 6l1.5-2 4.5 1.5v3a2 2 0 0 1-2 2A17 17 0 0 1 4.5 5a2 2 0 0 1 2-2Z" />
    </Svg>
  );
}

export function MobileIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="7" y="3" width="10" height="18" rx="2" />
      <path d="M11 18h2" />
    </Svg>
  );
}

export function MailIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </Svg>
  );
}

export function CompanyConnIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M4 21V7a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v14" />
      <path d="M12 11h7a1 1 0 0 1 1 1v9M7 10h.01M9.5 10h.01M7 13h.01M9.5 13h.01M15.5 15h.01M15.5 18h.01" />
    </Svg>
  );
}

export function RecordStatusIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9 12h6" />
    </Svg>
  );
}

export function VerificationIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M12 3 5 6v5c0 4.5 3 7.8 7 9 4-1.2 7-4.5 7-9V6Z" />
      <path d="m9 12 2 2 4-4" />
    </Svg>
  );
}

export function LocationRefIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M12 21s7-6.3 7-12a7 7 0 0 0-14 0c0 5.7 7 12 7 12Z" />
      <path d="M9 9h6M9 12h6M12 9v6" />
    </Svg>
  );
}
